<h3 class="mat-dialog-title">Upload Contacts From File</h3>
<div class="mat-dialog-content">
  <p *ngIf="!fileUploaded">
    Drag and drop a file, or click on the upload button to select a file to upload. (Excel, Text, CSV, Vcard)
  </p>
  <p *ngIf="fileUploaded && !fileProcessed">
    Choose a group to import into, and then select/match each field to a particular column from your uploaded file.
  </p>
  <p *ngIf="fileUploaded && fileProcessed">
    Confirm the detected contacts and then click on import to finalize your upload.
    <br> <b>Total: {{ contacts?.length || 0 }} contacts</b>
  </p>

  <p *ngIf="!fileUploaded" class="text-danger"><small>*Note: All contacts without a country code prefix will be
      automatically prefixed with your default country code</small></p>

  <div *ngIf="!fileUploaded" class="drop-zone" appDragDrop (onFileDropped)="onDropFile($event)">
    <div class="center text-center">
      <i class="icon ti-file"></i>
      <p>Drag and drop your file here</p>
      <p class="supported"><small>supported files: {{ supportedFiles.replace(',', ' ') }}</small></p>
      <label>
        <span class="btn btn-primary btn-sm btn-block">CHOOSE FILE</span>
        <input type="hidden" class="file-contents">
        <!-- <input type="file" style="display: none" name="file" accept="text/x-vcard" (change)="onUpload($event)"> -->
        <input #fileInput type="file" style="display: none" name="file" [accept]="supportedFiles"
          (change)="onChooseFile($event)">
      </label>
    </div>
  </div>

</div>

<hr *ngIf="fileUploaded">

<div class="private">
<div *ngIf="fileUploaded && !fileProcessed" class="">

  <!-- CSV UPLOAD -->
  <ng-container *ngIf="uploadFileType == 'csv'">

    <app-select-field [skipBlankItems]="true" #firstName name="First Name" [options]="parsedRowData" [(value)]="valuesHolder.surname" [required]="false" [helpText]="getFieldValues(valuesHolder.surname)"></app-select-field>

    <br>
    <app-select-field [skipBlankItems]="true" name="Other Name" [options]="parsedRowData" [(value)]="valuesHolder.othername" [helpText]="getFieldValues(valuesHolder.othername)"></app-select-field>

    <br>
    <app-select-field [skipBlankItems]="true" #mobile name="Mobile" [options]="parsedRowData" [(value)]="valuesHolder.mobile" [required]="true" [helpText]="getFieldValues(valuesHolder.mobile)"></app-select-field>

    <br>
    <app-select-field *ngIf="groups.length > 0" name="Group" [isObject]="true" [required]="true" [noEmptyValue]="true"
      [options]="groups" objectNameField="name" [(value)]="selectedGroup" (valueChange)="setGroupForContacts()" helpText="Group to save the contacts to"></app-select-field>

    <app-select-field [skipBlankItems]="true" *ngIf="selectedGroup && selectedGroup.custom_1" [name]="selectedGroup.custom_1"
      [options]="parsedRowData" [(value)]="valuesHolder.custom_1" [helpText]="getFieldValues(valuesHolder.custom_1)"></app-select-field>
    <app-select-field [skipBlankItems]="true" *ngIf="selectedGroup && selectedGroup.custom_2" [name]="selectedGroup.custom_2"
      [options]="parsedRowData" [(value)]="valuesHolder.custom_2" [helpText]="getFieldValues(valuesHolder.custom_2)"></app-select-field>
    <app-select-field [skipBlankItems]="true" *ngIf="selectedGroup && selectedGroup.custom_3" [name]="selectedGroup.custom_3"
      [options]="parsedRowData" [(value)]="valuesHolder.custom_3" [helpText]="getFieldValues(valuesHolder.custom_3)"></app-select-field>
    <app-select-field [skipBlankItems]="true" *ngIf="selectedGroup && selectedGroup.custom_4" [name]="selectedGroup.custom_4"
      [options]="parsedRowData" [(value)]="valuesHolder.custom_4" [helpText]="getFieldValues(valuesHolder.custom_4)"></app-select-field>

  </ng-container>

  <!-- TXT UPLOAD -->
  <ng-container *ngIf="uploadFileType == 'txt'">
    <app-select-field name="Delimiter" [options]="txtDelimiters" [required]="true" [noEmptyValue]="true" [(value)]="selectedTxtDelimiter" helpText="What character separates each of the contacts located in the file?"></app-select-field>

    <br>

    <app-select-field *ngIf="groups.length > 0" name="Group" [isObject]="true" [required]="true" [noEmptyValue]="true"
        [options]="groups" objectNameField="name" [required]="true" [(value)]="selectedGroup" (valueChange)="setGroupForContacts()" helpText="Group to save the contacts to"></app-select-field>
  </ng-container>

</div>

  <app-contacts-preview *ngIf="fileUploaded && fileProcessed" [contacts]="contacts" (onRemoveContact)="removeRecipient($event)"></app-contacts-preview>
</div>

<hr *ngIf="fileUploaded">

<div class="mat-dialog-actions pull-right">
  <button type="button" class="btn btn-default" tabindex="-1" (click)="dialogRef.close()">Cancel</button>
  &nbsp; &nbsp;
  <button *ngIf="fileUploaded && !fileProcessed" type="button" class="btn btn-primary" tabindex="1" (click)="onConfirmFields()">Next</button>
  <button *ngIf="fileProcessed" type="button" class="btn btn-primary" tabindex="1" (click)="onImport()" [disabled]="!fileUploaded || !fileProcessed">Import</button>
</div>
